import Article from "./Article";
import Book, { BookLg } from "./Book";
import Bookmark, { BookMarkLg } from "./Bookmark";
import BookmarkFilled from "./BookmarkFilled";
import Calendar from "./Calendar";
import CarrotUp from "./CarrotUp";
import CarrotDown from "./CarrotDown";
import Check, { CheckLg } from "./Check";
import Close from "./Close";
import ColorGradient, { ColorGradientLg } from "./ColorGradient";
import Document, { DocumentLg } from "./Document";
import Education, { EducationLg } from "./Education";
import Event, { EventLg } from "./Event";
import Hamburger from "./Hamburger";
import Location, { LocationLg } from "./Location";
import Membership, { MembershipLg } from "./Membership";
import Play from "./Play";
import Quote from "./Quote";
import Rainbow from "./Rainbow";
import Star, { StarLg } from "./Star";
import Search from "./Search";
import Smile, { SmileLg } from "./Smile";
import Thumb, { ThumbLg } from "./Thumb";
import Triangle from "./Triangle";
import WhiteCircleCheck from "./WhiteCircleCheck";
import WhiteCirclePlus from "./WhiteCirclePlus";

export {
	Article,
	Book,
	BookLg,
	Bookmark,
	BookMarkLg,
	BookmarkFilled,
	Calendar,
	CarrotUp,
	CarrotDown,
	Check,
	CheckLg,
	Close,
	ColorGradient,
	ColorGradientLg,
	Document,
	DocumentLg,
	Education,
	EducationLg,
	Event,
	EventLg,
	Hamburger,
	Location,
	LocationLg,
	Membership,
	MembershipLg,
	Play,
	Quote,
	Rainbow,
	Star,
	Search,
	StarLg,
	Smile,
	SmileLg,
	Thumb,
	ThumbLg,
	Triangle,
	WhiteCircleCheck,
	WhiteCirclePlus,
};
